import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppComponent from "./App";
import configureStore from "./store/Store";
import { App, ConfigProvider, theme } from "antd";
import MiniApp from "./components/MiniApp/MiniApp";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Telegram Mini App: its own page, outside the dashboard (no login / header)
const isMiniApp = window.location.pathname.startsWith("/tg");

root.render(
  <Provider store={configureStore}>
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorBgBase: "#111827",
        },
      }}
    >
      <App>
        {isMiniApp ? (
          <MiniApp />
        ) : (
          <BrowserRouter>
            <AppComponent />
          </BrowserRouter>
        )}
      </App>
    </ConfigProvider>
  </Provider>
);
